// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"style_paginationContainer__1a1_c"};